import { render } from "./lrbTable4.vue?vue&type=template&id=4b64f220&scoped=true"
import script from "./lrbTable4.vue?vue&type=script&lang=js"
export * from "./lrbTable4.vue?vue&type=script&lang=js"

import "./lrbTable4.vue?vue&type=style&index=0&id=4b64f220&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b64f220"]])

export default __exports__